
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftLeft0 as ObiThreewayAcuatorPistonInleftLeft0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-left-0.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftLeft0 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-left-0',
   elementClass: ObiThreewayAcuatorPistonInleftLeft0Element,
   events: {
     
   }
  });
 
 